<template>
  <el-tree
    :check-strictly="true"
    :data="treeData"
    node-key="id"
    :props="props"
    @node-click="handleClick"
    ref="dataTree"
  >
  </el-tree>

  <!-- :check-strictly="true" -->
  <!-- :load="loadNode" -->
</template>
<script>
export default {
  props: {
    treeData: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      subjectObj: {},
      props: {
        label: "name",
        children: "children",
        isLeaf: "id",
      },
    };
  },
  mounted() {},
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      this.subjectObj = data;

      // if (checked) {
      //   this.$refs.dataTree.setCheckedKeys([data.id]);
      //   this.company = data;
      // }
    },
    handleClick(data, node, _slef) {
      if (node.level === 2) {
        this.subjectObj = data;
      } else {
        this.subjectObj = null;
      }
    },
  },
};
</script>
